export default "__VITE_ASSET__140b4702__"